module.exports = __webpack_public_path__ + "static/media/linkedin.2ef8a519.svg";